<div class="modal-body">
  <p class="lead text-break" [innerHTML]="message"></p>
  <div class="text-center">
    <button class="btn btn-primary mr-2" (click)="confirm()"><fa-icon icon="check"></fa-icon> {{confirmLabel}}</button>
    <button class="btn btn-secondary" (click)="decline()"><fa-icon icon="times"></fa-icon> {{declineLabel}}</button>
  </div>
</div>
